// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'

const questionValidationErrors = {
  question: {
    required: 'Soru alanı girilmesi zorunludur',
    max: 'Soru alanı en fazla 200 karakter olmalıdır',
  },
  choice: {
    required: 'Cevap alanı girilmesi zorunludur',
    exact: '4 adet cevap girilmesi zorunludur',
    exists: 'Bu cevap çoktan girilmiş',
  },
  correct_choice: {
    required: 'Doğru cevap alanı girilmesi zorunludur',
    max: 'Doğru cevap alanı en fazla 200 karakter olmalıdır',
  },
  difficulty: {
    required: 'Zorluk alanı seçilmesi zorunludur',
  },
}

const { question, choice, correct_choice, difficulty } =
  questionValidationErrors

export const questionSearchSchema = adminListSearchSchema

export const createQuestionSchema = z.object({
  question: z.string().min(1, question.required).max(200, question.max),
  category_id: z.string().min(1, { message: 'Kategori seçilmesi zorunludur' }),
  subcategory_id: z.string().optional(),
  question_pool_id: z.string().nullable().optional(),
  match_modes: z.array(z.string()),
  difficulty: z.string().min(1, difficulty.required),
  choices: z
    .array(z.string().min(1, choice.required))
    .length(4, { message: choice.exact })
    .superRefine((choices, ctx) => {
      const seen = new Map<string, number[]>()

      choices.forEach((value, index) => {
        if (!value) return
        if (!seen.has(value)) {
          seen.set(value, [index])
        } else {
          seen.get(value)!.push(index)
        }
      })

      for (const indices of seen.values()) {
        if (indices.length > 1) {
          indices.forEach((i) => {
            ctx.addIssue({
              code: 'custom',
              message: choice.exists,
              path: [i],
            })
          })
        }
      }
    }),
  correct_choice: z
    .string()
    .min(1, correct_choice.required)
    .max(200, correct_choice.max),
})

export const editQuestionSchema = z.object({
  question: z.string().min(1, question.required).max(200, question.max),
  category_id: z.string().min(1, { message: 'Kategori seçilmesi zorunludur' }),
  subcategory_id: z.string().optional(),
  question_pool_id: z.string().nullable().optional(),
  match_modes: z.array(z.string()),
  difficulty: z.string().min(1, difficulty.required),
  choices: z
    .array(z.string().min(1, choice.required))
    .length(4, { message: choice.exact })
    .superRefine((choices, ctx) => {
      const seen = new Map<string, number[]>()

      choices.forEach((value, index) => {
        if (!value) return
        if (!seen.has(value)) {
          seen.set(value, [index])
        } else {
          seen.get(value)!.push(index)
        }
      })

      for (const indices of seen.values()) {
        if (indices.length > 1) {
          indices.forEach((i) => {
            ctx.addIssue({
              code: 'custom',
              message: choice.exists,
              path: [i],
            })
          })
        }
      }
    }),
  correct_choice: z
    .string()
    .min(1, correct_choice.required)
    .max(200, correct_choice.max),
})
